// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","expanded":"Footer_expanded__6XUpS","footerContent":"Footer_footerContent__GLsTv","mobile":"Footer_mobile__hjmW+"};